import { observer } from 'mobx-react-lite'
import { TagsSelect } from 'entities/Tags'
import type { TagsControl } from 'entities/Tags/store/tagsControl'

type ITagActionModalProps = {
  control: TagsControl
  canCreate: boolean
}

export const TagAction = observer(({ control, canCreate }: ITagActionModalProps) => (
  <TagsSelect
    control={control}
    canCreate={canCreate}
    placeholder={'Search'}
    searchPlaceholder={'Search'}
  />
))
